<template>
  <div class="col-span-12">
    <div class="grid grid-cols-12 gap-4">
      <div class="col-span-12 mx-auto mt-4">
        <table class="w-full leading-normal text-gray"
               style="border: solid 1px #dedede;">
          <thead class="bg-gray-pale" >
          <tr>
            <th colspan="12" class="py-2">
              <span class="px-2">Partner(s)</span>
            </th>
          </tr>
          </thead>
          <tbody>
            <PartnerDetails v-if="getBusinessPartners" class="p-1" :individuals="getBusinessPartners.individualPartners" :corporates="getBusinessPartners.corporatePartners"/>
            <tr v-else>
              <td colspan="8" class="bg-inertgrey text-center py-1">
                <span class="text-sm">No results found</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useBusinessFileStore } from "@/stores/business-file";
import PartnerDetails from "@/domains/home/services/registry/business/files/tabs/business_name_data/PartnerDetails.vue";

const fileStore = useBusinessFileStore();

const getBusinessPartners = computed(() => fileStore.partners);
</script>

